import FileUploadSettings from './toolbar/file-upload-settings.js';
import 'react';
import 'classnames';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './style-inject.es-746bb8ed.js';
import './pdfViewer/pdfConsts.js';
import './icons/fullViewerIcon.js';
import './icons/miniViewerIcon.js';

const Modals = {
  FILE_UPLOAD_SETTINGS: "file-upload-settings"
};
const ModalsMap = {
  [Modals.FILE_UPLOAD_SETTINGS]: FileUploadSettings
};

export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map
